/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/9
 */

import config from 'config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    current: {
        url: `${authApi}/api/modules/tree/current`,
        type: 'GET',
    },
}
